// Shown inside the shell (header included) for a module that is not open to this
// person: not held, or held but not switched on here.
import DeadEndWayOut from './DeadEndWayOut.jsx';

export default function ModuleUnavailable({ manifest, reason, help }) {
  return (
    <main className="mx-auto max-w-7xl px-4 py-16 text-center sm:px-6 lg:px-8">
      <h1 className="text-lg font-semibold">
        {reason === 'not-enabled' ? `${manifest.label} isn’t available yet.` : `You don’t have access to ${manifest.label}.`}
      </h1>
      <DeadEndWayOut help={help} />
    </main>
  );
}
